import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Collections from "./components/Collections";
import Categories from "./components/Categories";
import Rants from "./components/Rants";
import Memes from "./components/Memes";
import Stats from "./components/Stats";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { faqs } from "@/mocks/comics";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href="#home"
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 grid h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-md transition-all duration-300 hover:bg-primary-600 ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </a>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Collections />
        <Categories />
        <Rants />
        <Memes />
        <Stats />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                name: "韩国歪歪漫画",
                alternateName: "韩国歪歪漫画搞笑沙雕合集",
                url: "https://manghilar.github.io/",
                description:
                  "韩国歪歪漫画专供搞笑与无厘头内容，收录沙雕日常、神吐槽、梗图段子，无厘头剧情持续更新。",
                inLanguage: "zh-CN",
              },
              {
                "@type": "Organization",
                name: "韩国歪歪漫画",
                url: "https://manghilar.github.io/",
                email: "hello@waiwaicomics.cn",
              },
              {
                "@type": "ItemList",
                name: "热门沙雕合集",
                itemListElement: [
                  { "@type": "ListItem", position: 1, name: "沙雕室友的迷惑日常" },
                  { "@type": "ListItem", position: 2, name: "打工人的周一精神状态" },
                  { "@type": "ListItem", position: 3, name: "地铁上的灵魂画手" },
                  { "@type": "ListItem", position: 4, name: "爸妈迷惑行为图鉴" },
                ],
              },
              {
                "@type": "FAQPage",
                mainEntity: faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
                })),
              },
            ],
          }),
        }}
      />
    </div>
  );
}